import { protocolBrandPath } from '@hub/common';
import {
  firebaseConfig,
  STORAGE_EMULATOR_HOST,
} from 'features/firebase/firebaseConfig';

const STORAGE_ORIGIN =
  import.meta.env.MODE === 'development'
    ? `http://${STORAGE_EMULATOR_HOST}`
    : 'https://firebasestorage.googleapis.com';

/** The public download URL of a protocol's brand copy in the app's Storage
 *  bucket; the Storage emulator's in development. */
export const protocolBrandUrl = (protocolId: string): string =>
  `${STORAGE_ORIGIN}/v0/b/${firebaseConfig.storageBucket ?? ''}/o/${encodeURIComponent(protocolBrandPath(protocolId))}?alt=media`;
